// extracted by mini-css-extract-plugin
export var animationContainer = "_h2-0";
export var asteriskIcon = "_h2-8";
export var conversationLeftSection = "_h2-4";
export var conversationListItem = "_h2-3";
export var conversationMiddleSection = "_h2-5";
export var conversationRightSection = "_h2-6";
export var detailsContent = "_h2-1";
export var listContainer = "_h2-7";
export var modalContent = "_h2-2";